export default __webpack_public_path__ + "static/gitex-video-e8ab5767edffe42248f29fa262fde63a.png";